{
  "accountScreen": {
    "downloadCta": "Tải tài liệu đã ký",
    "helpDescription": "Gửi email cho chúng tôi tại <underline>{{email}}</underline>",
    "helpTitle": "Bạn cần trợ giúp hoặc có thắc mắc?",
    "loggedInWith": "Đã đăng nhập bằng {{method}}",
    "title": "Tài khoản",
    "usernameLoginMethod": "Tên người dùng"
  },
  "addHouseholdMemberScreen": {
    "addAnother": "Thêm người khác",
    "addingMemberDescription": "Chúng tôi muốn biết những ai đang sống cùng bạn.",
    "addingMemberTitle": "Giới thiệu về họ",
    "age": "Tuổi",
    "coverageCheck": {
      "dateOfBirth": "Ngày sinh (không bắt buộc)",
      "description": "Không bắt buộc. Thông tin này giúp chúng tôi tìm các chương trình bảo hiểm họ có thể đã có.",
      "medicaidId": "Mã số Medicaid (không bắt buộc)",
      "medicaidIdPlaceholder": "Nhập mã số Medicaid",
      "ssn": "Số An sinh Xã hội - SSN (không bắt buộc)",
      "ssnPlaceholder": "XXX-XX-XXXX",
      "title": "Để giúp chúng tôi kiểm tra bảo hiểm của họ"
    },
    "duplicateDialog": {
      "cancel": "Không, quay lại",
      "checkError": "Chúng tôi không thể kiểm tra các thành viên trong hộ gia đình bạn. Vui lòng thử lại.",
      "confirm": "Đúng, là người khác",
      "description": "Bạn đã thêm <bold>{{name}}</bold>. Người bạn đang thêm có phải là một người khác không?",
      "descriptionWithDetails": "Bạn đã thêm <bold>{{name}}</bold> ({{details}}). Người bạn đang thêm có phải là một người khác không?",
      "reminder": "Bạn không cần thêm lại những người bạn đã thêm.",
      "title": "Đây có phải là thành viên mới không?"
    },
    "enterDateOfBirth": "Hoặc nhập ngày sinh",
    "enterRelationship": "Nhập mối quan hệ",
    "firstName": "Tên",
    "formSubmission": {
      "error": "Chúng tôi không thể thêm thành viên này. Vui lòng thử lại.",
      "success": "Đã thêm {{firstName}} thành công"
    },
    "lastName": "Họ",
    "livingWithMe": "Sống cùng tôi",
    "relationshipToMe": "Mối quan hệ với tôi",
    "sameMailingAddress": "Cùng địa chỉ nhận thư",
    "updateFormSubmission": {
      "success": "Đã cập nhật {{firstName}} thành công"
    },
    "validations": {
      "ageOrDateOfBirthRequired": "Vui lòng nhập độ tuổi hoặc ngày sinh.",
      "futureDateOfBirth": "Vui lòng nhập ngày sinh vào hoặc trước ngày hôm nay.",
      "invalidDateOfBirth": "Vui lòng nhập ngày sinh hợp lệ (MM/DD/YYYY).",
      "selectAnOption": "Vui lòng chọn một tùy chọn.",
      "specifyRelationship": "Vui lòng cho biết mối quan hệ của người này với bạn."
    }
  },
  "appFooter": {
    "partnershipLabel": "Hợp tác cùng"
  },
  "appHeader": {
    "toggleThemeTooltip": "Theme Toggle is temporary for debugging."
  },
  "appMenu": {
    "account": "Tài khoản",
    "household": "Hộ gia đình",
    "language": "Ngôn ngữ",
    "logout": "Đăng xuất"
  },
  "applicantDocuments": {
    "alsoCompleted": "Tài liệu này cũng đã hoàn thành {{section}}.",
    "alsoCompletedResidenceForMembers": "Tài liệu này cũng đã hoàn thành {{section}} cho các thành viên trong hộ gia đình sống cùng địa chỉ",
    "deleteDialog": {
      "description": "Bạn có chắc muốn xóa tài liệu này không? Hành động này không thể phục hồi.",
      "title": "Xóa tài liệu"
    },
    "deleteToast": {
      "error": "Chúng tôi không thể xóa tài liệu đó. Vui lòng thử lại.",
      "success": "Đã xóa tài liệu thành công"
    },
    "immigrationIncomplete": {
      "description": "Bạn vẫn cần tải lên Mã số USCIS, giấy tờ nhập cư/phê duyệt, hoặc I-20 để hoàn thành {{section}}.",
      "dismiss": "Đã hiểu",
      "title": "Cần thêm một tài liệu nữa"
    },
    "optional": "Không bắt buộc",
    "progress": "Hoàn thành {{completeCount}} trên {{applicableCount}}",
    "selectDocumentType": "Chọn loại giấy tờ",
    "ssn": {
      "cardOption": "Hoặc tải lên Thẻ An sinh Xã hội của bạn",
      "label": "Số An sinh Xã hội",
      "save": "Lưu",
      "saveError": "Chúng tôi không thể lưu số đó. Vui lòng thử lại.",
      "saved": "Đã lưu Số An sinh Xã hội"
    },
    "supportedFiles": "Định dạng hỗ trợ: PDF, JPG, PNG",
    "upload": {
      "failed": "Không thể tải tài liệu này lên. Vui lòng thử lại.",
      "failedDescription": "Chúng tôi không thể đọc tệp này. Vui lòng xóa nó và tải lên bản mới.",
      "uploading": "Đang tải lên..."
    },
    "uploadOne": "Tải lên <bold>ít nhất một loại:</bold>"
  },
  "applicationAddressScreen": {
    "description": "Vui lòng kiểm tra và xác nhận địa chỉ nhà và địa chỉ nhận thư cho mọi người.",
    "homeAddress": "Địa chỉ nhà",
    "isHomeless": "Không có địa chỉ nhà cố định",
    "mailingAddress": "Địa chỉ nhận thư",
    "needsHomeAddress": "<italic>Cần địa chỉ nhà</italic>",
    "needsMailingAddress": "<italic>Cần địa chỉ nhận thư</italic>",
    "noMailingAddress": "Không có địa chỉ nhận thư",
    "sameHomeAddress": "Cùng địa chỉ nhà",
    "sameMailingAddress": "Cùng địa chỉ nhận thư",
    "title": "Thông tin địa chỉ",
    "updateHouseholdAddressesDialog": {
      "addressTypeHome": "địa chỉ nhà",
      "addressTypeHomeAndMailing": "địa chỉ nhà và nhận thư",
      "addressTypeMailing": "địa chỉ nhận thư",
      "description_one": "{{householdName}} và {{count}} người khác hiện đang dùng chung {{addressType}} của bạn. Bạn có muốn cập nhật của họ không?",
      "description_other": "{{householdName}} và {{count}} người khác hiện đang dùng chung {{addressType}} của bạn. Bạn có muốn cập nhật của họ không?",
      "description_zero": "{{householdName}} hiện đang dùng chung {{addressType}} của bạn. Bạn có muốn cập nhật của họ không?",
      "onlyUpdateMine": "Không, chỉ cập nhật của tôi",
      "title": "Cập nhật địa chỉ hộ gia đình",
      "updateMembers_one": "Cập nhật {{count}} thành viên",
      "updateMembers_other": "Cập nhật {{count}} thành viên"
    },
    "you": "{{name}} (Bạn)"
  },
  "applicationChildCaregiverStatusScreen": {
    "description": "Trẻ em phải <bold>sống cùng thành viên này</bold> hơn <bold>nửa năm</bold> và người này phải <bold>chu cấp hơn một nửa</bold> chi phí hàng năm (ăn ở, học tập, y tế). Bao gồm cả trẻ không cùng huyết thống.",
    "title": "Những người này có sống cùng và chăm sóc trẻ em dưới 19 tuổi không?"
  },
  "applicationCitizenshipStatusScreen": {
    "description": "Có phải <bold>{{householdMembersNames}}</bold> đều là Công dân Hoa Kỳ không?",
    "hintDescription": "Nếu bạn chọn <bold>Không</bold>, đừng lo lắng. Vẫn có những lựa chọn khác dựa trên tình trạng cư trú của bạn.",
    "noDescription": "Một số hoặc tất cả không phải Công dân Hoa Kỳ",
    "title": "Điều kiện tham gia",
    "yesDescription": "Tất cả mọi người là Công dân Hoa Kỳ"
  },
  "applicationConfirmationScreen": {
    "brokerDeclined": {
      "description": "Chọn “Có, kết nối tôi” để được hỗ trợ giữ bác sĩ của bạn và bảo hiểm cho gia đình ở cùng một nơi.",
      "summaryWithMedicaid": "Chúng tôi sẽ xem xét hồ sơ Medicaid của bạn và liên hệ nếu cần bất cứ điều gì. Bạn vẫn cần một đại lý bảo hiểm được cấp phép để hoàn tất đăng ký {{programs}}.",
      "summaryWithoutMedicaid": "Chúng tôi đã nhận được những gì bạn gửi. Bạn vẫn cần một đại lý bảo hiểm được cấp phép để hoàn tất đăng ký {{programs}}.",
      "title": "Bạn đã chọn không kết nối với đại lý bảo hiểm được cấp phép. Bạn có chắc không?"
    },
    "continueButton": "Tiếp tục",
    "description": "Đội ngũ của chúng tôi sẽ xem xét hồ sơ của bạn và sẽ liên hệ nếu chúng tôi cần bất cứ điều gì. Khi mọi thứ ổn thỏa, chúng tôi sẽ gửi hồ sơ đến các chương trình bạn đã chọn.",
    "title": "Chúng tôi đã nhận được hồ sơ của bạn!"
  },
  "applicationCoverageStatusScreen": {
    "description": "<bold>{{householdMembersNames}}</bold> đã có bảo hiểm y tế chưa? Bao gồm cả bảo hiểm sắp có hiệu lực.",
    "noDescription": "Chưa có ai có bảo hiểm",
    "pleaseSpecify": "Vui lòng ghi rõ",
    "title": "Tình trạng bảo hiểm",
    "whatType": "Loại bảo hiểm gì?",
    "who": "Ai đã có bảo hiểm?",
    "yesDescription": "Thành viên đã có bảo hiểm"
  },
  "applicationDateOfBirthScreen": {
    "description": "Vui lòng thêm và xác nhận cho tất cả thành viên trong gia đình",
    "success": "Đã lưu tất cả ngày sinh",
    "title": "Ngày sinh"
  },
  "applicationDocuments": {
    "description": "Chúng tôi sẽ dùng các giấy tờ này để xác nhận thông tin của bạn. Bạn có thể tải lên ngay hoặc quay lại sau.",
    "title": "Tải tài liệu lên"
  },
  "applicationExpensesScreen": {
    "addAnotherExpense": "Thêm chi phí khác",
    "addExpense": "Thêm chi phí",
    "description": "Thêm các khoản chi phí y tế hoặc khoản giảm trừ cho mỗi người.",
    "expenseTypes": {
      "ALIMONY_PAID": "Tiền cấp dưỡng cho vợ/chồng cũ",
      "CHILDCARE": "Chi phí chăm sóc trẻ",
      "IRA_CONTRIBUTIONS": "Đóng góp quỹ hưu trí IRA",
      "MEDICAL_EXPENSES": "Chi phí y tế",
      "MOVING_EXPENSES": "Chi phí chuyển nhà",
      "NONE": "Không có",
      "OTHER": "Khác",
      "STUDENT_LOANS": "Khoản vay sinh viên",
      "TUITION_FEES": "Học phí"
    },
    "memberDialog": {
      "alertDescriptions": {
        "MEDICAL_EXPENSES": "Chúng tôi sẽ cần bằng chứng về chi phí này sau, vì vậy hãy chuẩn bị sẵn hóa đơn y tế hoặc biên lai nhà thuốc.",
        "OTHER": "Chúng tôi sẽ cần bằng chứng về chi phí này sau.",
        "STUDENT_LOANS": "Chúng tôi sẽ cần bằng chứng sau, có thể là sao kê khoản vay hoặc thư báo của nhà trường."
      },
      "medicalExpenses3MonthsHelpNeededStatus": "Trong 3 tháng qua, bạn có chi phí y tế cần hỗ trợ chi trả không?",
      "title": "Chọn một loại chi phí"
    },
    "monthlyExpense": "{{monthlyExpense}} / tháng",
    "progress": "Tiến độ: {{progress}} trên {{total}} đã xong",
    "title": "Chi phí sinh hoạt"
  },
  "applicationFlow": {
    "amountPerMonth": "Số tiền mỗi tháng"
  },
  "applicationForm": {
    "applyingToCounter": "Đang đăng ký {{programsCount}} chương trình cho {{householdMembersCount}} người",
    "continueButton": "Tiếp tục đăng ký",
    "greatNews": "Tin Vui!",
    "letsCreateApplications": "Hãy cùng tạo đơn đăng ký cho mọi người.",
    "mayBeEligible": "<bold>{{names}}</bold> có thể đủ điều kiện",
    "mayBeEligibleFor": "{{memberNames}} có thể đủ điều kiện cho <bold>{{brand}}</bold>",
    "notEligible": "Chưa đủ điều kiện vào lúc này",
    "programConflictDialog": {
      "description": "Đăng ký {{newProgram}} sẽ xóa đơn đăng ký {{currentPrograms}} của {{memberNames}}. {{memberNames}} không thể đăng ký cả hai cùng lúc. Khi bạn gửi đơn, chúng tôi sẽ đảm bảo {{memberNames}} ở đúng chương trình.",
      "description_members": "Đăng ký {{newProgram}} sẽ xóa các đơn đăng ký {{currentPrograms}} của {{memberNames}}. {{memberNames}} không thể đăng ký cả hai cùng lúc. Khi bạn gửi đơn, chúng tôi sẽ đảm bảo {{memberNames}} đều ở đúng chương trình.",
      "description_self": "Đăng ký {{newProgram}} sẽ xóa đơn đăng ký {{currentPrograms}} của bạn. Bạn không thể đăng ký cả hai cùng lúc. Khi bạn gửi đơn, chúng tôi sẽ đảm bảo bạn ở đúng chương trình.",
      "keepButton": "Giữ {{currentPrograms}}",
      "multipleDescription": "Đăng ký {{newProgram}} sẽ xóa các đơn đăng ký {{currentPrograms}} của {{memberNames}}. {{memberNames}} không thể đăng ký tất cả cùng lúc. Khi bạn gửi đơn, chúng tôi sẽ đảm bảo {{memberNames}} ở đúng chương trình.",
      "multipleDescription_members": "Đăng ký {{newProgram}} sẽ xóa các đơn đăng ký {{currentPrograms}} của {{memberNames}}. {{memberNames}} không thể đăng ký tất cả cùng lúc. Khi bạn gửi đơn, chúng tôi sẽ đảm bảo {{memberNames}} đều ở đúng chương trình.",
      "multipleDescription_self": "Đăng ký {{newProgram}} sẽ xóa các đơn đăng ký {{currentPrograms}} của bạn. Bạn không thể đăng ký tất cả cùng lúc. Khi bạn gửi đơn, chúng tôi sẽ đảm bảo bạn ở đúng chương trình.",
      "recommendMedicaidDescription": "{{memberNames}} không thể đăng ký cả hai cùng lúc. Medicaid miễn phí và {{memberNames}} đủ điều kiện. Khi bạn gửi đơn, chúng tôi sẽ đảm bảo {{memberNames}} ở đúng chương trình.",
      "recommendMedicaidDescription_members": "{{memberNames}} không thể đăng ký cả hai cùng lúc. Medicaid miễn phí và {{memberNames}} đều đủ điều kiện. Khi bạn gửi đơn, chúng tôi sẽ đảm bảo {{memberNames}} đều ở đúng chương trình.",
      "recommendMedicaidDescription_self": "Bạn không thể đăng ký cả hai cùng lúc. Medicaid miễn phí và bạn đủ điều kiện. Khi bạn gửi đơn, chúng tôi sẽ đảm bảo bạn ở đúng chương trình.",
      "recommendMedicaidTitle": "Chúng tôi khuyên bạn nên đăng ký Medicaid",
      "switchButton": "Chuyển sang {{newProgram}}",
      "title": "Bạn chỉ có thể đăng ký một chương trình"
    },
    "programsFound": "Chúng tôi tìm thấy {{programsCount}} chương trình phù hợp cho tất cả {{householdMembersCount}} người.",
    "recentDuplicateDialog": {
      "continueAnyway": "Vẫn tiếp tục",
      "description": "Gần đây, bạn đã gửi đơn đăng ký <bold>{{applicationType}}</bold> cho {{memberNames}}. Bạn chỉ nên gửi đơn khác nếu có điều gì đó thay đổi.",
      "multipleDescription": "Gần đây, bạn đã gửi các đơn đăng ký <bold>{{applicationTypes}}</bold> cho {{memberNames}}. Bạn chỉ nên gửi đơn khác nếu có điều gì đó thay đổi.",
      "title": "Gần đây bạn đã gửi một đơn đăng ký"
    },
    "startButton": "Bắt đầu đăng ký"
  },
  "applicationMaritalStatusScreen": {
    "description": "Chúng tôi đã thiết lập tình trạng hôn nhân dựa trên thông tin bạn chia sẻ. Vui lòng kiểm tra lại.",
    "needsMaritalStatus": "Cần tình trạng hôn nhân",
    "title": "Tình trạng hôn nhân"
  },
  "applicationOtherStatusesScreen": {
    "conditions": {
      "americanIndianOrAlaskaNative": "Người Mỹ bản địa hoặc người Alaska",
      "needsHelpDailyActivities": "Cần hỗ trợ trong sinh hoạt hàng ngày",
      "studentFullTime18to20": "Sinh viên toàn thời gian (18 - 20 tuổi)",
      "veteranOrMilitaryMember": "Cựu chiến binh hoặc quân nhân"
    },
    "description": "Vui lòng chọn bất kỳ tình huống nào đúng với mọi người trong nhà.",
    "errors": {
      "unableToUpdateHouseholdMembers": "Chúng tôi không thể lưu các thay đổi đó. Vui lòng thử lại."
    },
    "title": "Các tình trạng khác"
  },
  "applicationSection": {
    "applications": "Đơn đăng ký",
    "beginYourApplicationCompact": "Đăng ký trong 15 phút hoặc ít hơn",
    "beginYourApplicationProcess": "Bắt đầu đăng ký để có bảo hiểm trong 15 phút hoặc ít hơn",
    "continueQuickApply": "Tiếp tục Đăng ký nhanh",
    "continueYourApplicationCompact": "Tiếp tục đăng ký của bạn",
    "continueYourApplicationProcess": "Tiếp tục đăng ký để có bảo hiểm trong 15 phút hoặc ít hơn",
    "newQuickApply": "Đăng ký nhanh mới",
    "quickApply": "Đăng ký nhanh"
  },
  "applicationSubmitScreen": {
    "description": "Bạn đã hoàn thành tất cả các bước. Khi bạn sẵn sàng, hãy gửi đơn đăng ký bên dưới.",
    "hintMessage": "Bạn không thể thay đổi sau khi gửi. Xin kiểm tra chính xác mọi thông tin.",
    "partialFailure": "Một số hồ sơ đăng ký bảo hiểm của bạn có thể chưa được gửi. Vui lòng kiểm tra lại trong danh sách hồ sơ.",
    "submitButton": "Gửi đơn đăng ký",
    "success": "Đã gửi đơn đăng ký thành công.",
    "title": "Mọi thứ đã sẵn sàng!"
  },
  "applicationTaxInformationScreen": {
    "description": "Dựa trên thông tin bạn chia sẻ, đây là tình trạng thuế dự kiến của mọi người. Vui lòng kiểm tra lại.",
    "errors": {
      "unableToUpdateRelationship": "Chúng tôi không thể cập nhật mối quan hệ đó. Vui lòng thử lại."
    },
    "memberCard": {
      "dependentOf": "Người phụ thuộc của: {{name}}",
      "dependents": "Người phụ thuộc: {{name}}",
      "memberDialog": {
        "description": "Kiểm tra và cập nhật chi tiết thuế nếu cần.",
        "saveAndReturn": "Lưu và quay lại",
        "taxClaimedAsDependentStatus": "Có ai khai người này là người phụ thuộc không?",
        "taxDependentsClaimedStatus": "Người này có khai ai là người phụ thuộc không?",
        "taxFilingStatus": "Tình trạng thuế",
        "title": "Thông tin thuế – {{name}}",
        "who": "Là ai?"
      }
    },
    "needsTaxInformation": "Cần thông tin thuế",
    "success": "Đã cập nhật thông tin thuế thành công",
    "title": "Thông tin thuế"
  },
  "applicationWorkAndIncomeScreen": {
    "addAnotherIncome": "Thêm thu nhập khác",
    "addIncome": "Thêm thu nhập",
    "description": "Thêm thông tin việc làm và thu nhập cho mỗi người.",
    "incomeTypes": {
      "ALIMONY": "Tiền cấp dưỡng",
      "EMPLOYED": "Đi làm (có chủ thuê)",
      "NONE": "Không có",
      "OTHER": "Khác",
      "PENSION": "Tiền lương hưu",
      "PROPERTY_RENTAL_INCOME": "Thu nhập cho thuê nhà đất",
      "RETIREMENT_INCOME": "Thu nhập hưu trí",
      "SELF_EMPLOYED": "Tự kinh doanh",
      "SSA": "An sinh Xã hội (SSA)",
      "SSDI": "Trợ cấp khuyết tật (SSDI)",
      "UNEMPLOYED": "Thất nghiệp",
      "WORKERS_COMPENSATION": "Bồi thường tai nạn lao động"
    },
    "memberDialog": {
      "alertDescriptions": {
        "EMPLOYED": "Chúng tôi sẽ cần bằng chứng thu nhập sau (như cuống lương hoặc mẫu W-2).",
        "OTHER": "Chúng tôi sẽ cần bằng chứng sau (như thư báo trợ cấp hoặc quyền lợi).",
        "SELF_EMPLOYED": "Chúng tôi sẽ cần bằng chứng sau (như hóa đơn hoặc mẫu 1099).",
        "UNEMPLOYED": "Chúng tôi sẽ cần bằng chứng sau (như thư xác nhận trợ cấp thất nghiệp)."
      },
      "employerName": "Tên chủ thuê/Công ty",
      "enterName": "Nhập tên",
      "enterTypeOfWork": "Nhập loại công việc",
      "grossMonthlyIncome": "Tổng thu nhập hàng tháng (trước thuế)",
      "payFrequency": "Tần suất trả lương",
      "selfEmploymentNetMonthlyIncome": "Thu nhập RÒNG hàng tháng ước tính (sau chi phí)",
      "title": "Chọn loại thu nhập",
      "typeOfWork": "Loại công việc",
      "unemploymentCompensationStatus": "Bạn có nhận trợ cấp thất nghiệp không?",
      "workWeekHours": "Số giờ làm mỗi tuần"
    },
    "monthlyIncome": "{{monthlyIncome}} / tháng",
    "title": "Việc làm & Thu nhập"
  },
  "applicationsListScreen": {
    "applicationDate": "Ngày DD/MM/YYYY [lúc] h:mm A",
    "inProgress": "Đang xử lý",
    "noApplications": "Bạn chưa có hồ sơ nào.",
    "submitted": "Đã gửi",
    "title": "Đơn đăng ký {{applicationType}}"
  },
  "authScreen": {
    "appleSignInFailed": "Chúng tôi không thể đăng nhập cho bạn bằng Apple. Vui lòng thử lại hoặc dùng cách khác.",
    "checkYourEmail": "Kiểm tra email của bạn",
    "checkYourSpam": "Không nhận được? Hãy kiểm tra thư rác hoặc đợi vài phút rồi thử lại.",
    "continueWithApple": "Tiếp tục với Apple",
    "continueWithGoogle": "Tiếp tục với Google",
    "dataSecured": "Dữ liệu của bạn được an toàn. Tuân thủ HIPAA & SOC 2.",
    "emailInput": "Địa chỉ Email",
    "googleSignInFailed": "Chúng tôi không thể đăng nhập cho bạn bằng Google. Vui lòng thử lại hoặc dùng cách khác.",
    "identifierInput": "Email hoặc tên người dùng",
    "invalidIdentifier": "Vui lòng nhập email hoặc tên người dùng hợp lệ.",
    "subtitle": "Nhập email hoặc tên người dùng để tiếp tục.",
    "title": "Đăng nhập hoặc Tạo tài khoản",
    "weSentALink": "Chúng tôi đã gửi liên kết đến <bold>{{email}}</bold>. Nhấp vào đó để tiếp tục.",
    "youAgree": "Bằng cách tiếp tục, bạn đồng ý với <underline><colorEmphasis>Điều khoản dịch vụ</colorEmphasis></underline> và <privacyLink><colorEmphasis>Chính sách bảo mật</colorEmphasis></privacyLink>."
  },
  "brokerConsent": {
    "noButton": "Không, cảm ơn",
    "recommendedBadge": "Khuyến nghị",
    "yesButton": "Có, kết nối tôi"
  },
  "brokerConsentScreen": {
    "continueWithMedicaidOnlyButton": "Tiếp tục chỉ với Medicaid",
    "continueWithoutAgentButton": "Tiếp tục mà không có đại lý",
    "declineCard": {
      "applyLink": "Đăng ký {{program}}",
      "fallbackWithMedicaid": "Bạn vẫn có thể tiếp tục hồ sơ Medicaid của mình tại đây. Pointcare có thể xử lý hồ sơ Medicaid của bạn mà không cần đại lý.",
      "fallbackWithoutMedicaid": "Bạn vẫn có thể tiếp tục hồ sơ của mình tại đây. Hoàn tất ngay bây giờ nghĩa là Pointcare có thể hỗ trợ bạn khi nhu cầu bảo hiểm thay đổi.",
      "selfEnrollmentWarning": "Nếu không có đại lý, bạn sẽ phải tự đăng ký {{programs}}.",
      "title": "Chọn “Có, kết nối tôi” để tận dụng tối đa Pointcare"
    },
    "subtitle": "Chúng tôi sẽ kết nối bạn khi đến lúc đăng ký và chỉ chia sẻ những gì cần thiết để hỗ trợ.",
    "subtitleWithIndividual": "Chúng tôi sẽ kết nối bạn khi đến lúc đăng ký và chỉ chia sẻ những gì cần thiết để hỗ trợ. Nếu bạn đang đăng ký Medicare, đại lý này sẽ là {{brokerName}}.",
    "subtitleWithIndividualLicense": "Chúng tôi sẽ kết nối bạn khi đến lúc đăng ký và chỉ chia sẻ những gì cần thiết để hỗ trợ. Nếu bạn đang đăng ký Medicare, đại lý này sẽ là {{brokerName}} (Số giấy phép: {{licenseNumber}}).",
    "subtitleWithOrganization": "Chúng tôi sẽ kết nối bạn khi đến lúc đăng ký và chỉ chia sẻ những gì cần thiết để hỗ trợ. Nếu bạn đang đăng ký Medicare, đại lý này sẽ đến từ {{brokerName}}.",
    "subtitleWithOrganizationLicense": "Chúng tôi sẽ kết nối bạn khi đến lúc đăng ký và chỉ chia sẻ những gì cần thiết để hỗ trợ. Nếu bạn đang đăng ký Medicare, đại lý này sẽ đến từ {{brokerName}} (Số giấy phép: {{licenseNumber}}).",
    "title": "Kết nối với đại lý bảo hiểm được cấp phép để tìm hiểu các lựa chọn Medicare và/hoặc Marketplace ACA và được hỗ trợ hoàn tất đăng ký"
  },
  "camera": {
    "grantPermission": "Cấp quyền truy cập",
    "permissionDescription": "Để chụp ảnh tài liệu, vui lòng cho phép truy cập máy ảnh trong phần cài đặt điện thoại.",
    "permissionRequired": "Chúng tôi cần quyền truy cập vào máy ảnh của bạn.",
    "photoCount": "Đã chụp {{count}} ảnh",
    "tapToCapture": "Nhấn nút để chụp ảnh"
  },
  "cesSurvey": {
    "feedbackLabel": "Điều gì khiến việc này khó khăn?",
    "feedbackPlaceholder": "Cho chúng tôi biết thêm",
    "optionalLabel": "Không bắt buộc",
    "questions": {
      "consentFormSigned": "Việc hiểu nội dung bạn đã ký dễ đến mức nào?",
      "householdMemberAdded": "Việc thêm một thành viên hộ gia đình dễ đến mức nào?",
      "incomeAdded": "Việc thêm thu nhập dễ đến mức nào?"
    },
    "scoreEasy": "Dễ",
    "scoreHard": "Khó",
    "scoreOk": "Bình thường",
    "scoreVeryEasy": "Rất dễ",
    "scoreVeryHard": "Rất khó",
    "thanksDescription": "Phản hồi của bạn giúp chúng tôi cải thiện.",
    "thanksTitle": "Cảm ơn bạn!"
  },
  "consentDocuments": {
    "addSignature": "Thêm chữ ký",
    "description": "Ký bên dưới để chúng tôi có thể hỗ trợ bạn.",
    "documentTitle": "Giấy ủy quyền cung cấp thông tin (PDF)",
    "grant1": "Theo dõi bảo hiểm và phát hiện sớm các vấn đề",
    "grant2": "Thay mặt bạn phản hồi các yêu cầu - không lo thất lạc thư từ",
    "grant3": "Gửi đơn đăng ký và gia hạn, và theo dõi để bạn không bao giờ lỡ hạn",
    "grant4": "Liên hệ với bạn cho mục đích tiếp thị qua cuộc gọi điện thoại thông thường hoặc tự động, tin nhắn thoại và tin nhắn văn bản",
    "grantHealthPlanSelection": "Áp dụng lựa chọn chương trình bảo hiểm sức khỏe và bác sĩ của bạn (khi có) vào phạm vi bảo hiểm của bạn",
    "grantSubtitle": "Đây là những gì bao gồm:",
    "healthPlanAvailabilityError": "Chúng tôi không thể kiểm tra các chương trình bảo hiểm sức khỏe hiện có. Vui lòng thử lại trước khi ký.",
    "signatureCountsAsInitials": "Chữ ký của bạn cũng được tính là chữ viết tắt tên của bạn trên biểu mẫu khi áp dụng.",
    "title": "Quản lý bảo hiểm của gia đình bạn",
    "viewDocument": "Xem tài liệu"
  },
  "coverage": {
    "code": "Mã:",
    "coverageStatus": "Tình trạng bảo hiểm",
    "inProgress": "Đang xử lý",
    "isCovered": "{{name}} được bảo hiểm bởi {{programs}}.",
    "lastCheck": "Kiểm tra lần cuối",
    "lastCheckDateFormat": "DD/MM/YYYY",
    "lastCheckWithDate": "Kiểm tra lần cuối {{date}}",
    "noMatchingRecord": "Chúng tôi không thể tìm thấy bảo hiểm của bạn. Vui lòng kiểm tra lại thông tin và thử lại.",
    "planName": "Tên chương trình",
    "primaryCareProvider": "Bác sĩ chăm sóc chính",
    "programCoverage": "Bảo hiểm {{program}}",
    "programListing": {
      "medicaid": "<bold>Medicaid</bold>",
      "medicare": "<bold>Medicare</bold>",
      "medicareAndMedicaid": "<bold>Medicare</bold> và <bold>Medicaid</bold>"
    },
    "serviceTypes": "Loại dịch vụ",
    "status": {
      "checking": "Đang kiểm tra bảo hiểm...",
      "checkingShort": "Đang kiểm tra...",
      "covered": "Có bảo hiểm",
      "coveredBy": "Bảo hiểm bởi {{ programs }}",
      "notCovered": "Chưa có bảo hiểm",
      "unknown": "Không rõ tình trạng",
      "unknownShort": "Không rõ"
    },
    "updateProfileInformation": "Cập nhật thông tin cá nhân"
  },
  "createPasswordScreen": {
    "passwordInputLabel": "Mật khẩu",
    "passwordInputPlaceholder": "Tạo mật khẩu",
    "passwordRequirement": "Sử dụng ít nhất 10 ký tự.",
    "subtitle": "Bảo vệ tài khoản mới bằng mật khẩu mạnh để tiếp tục.",
    "title": "Tạo mật khẩu"
  },
  "createUsernameAccountScreen": {
    "passwordInputLabel": "Mật khẩu",
    "passwordInputPlaceholder": "Tạo mật khẩu",
    "subtitle": "Bảo vệ tài khoản mới bằng mật khẩu mạnh để tiếp tục.",
    "title": "Tạo mật khẩu"
  },
  "dateOfBirthInput": {
    "dayPlaceholder": "Ngày",
    "monthPlaceholder": "Tháng",
    "yearPlaceholder": "Năm"
  },
  "eligibilityHouseholdIncomeScreen": {
    "description1": "Sử dụng thu nhập GỘP (trước thuế). Nếu tự kinh doanh, hãy dùng thu nhập ròng (sau chi phí).",
    "description2": "Bao gồm thu nhập ước tính của tất cả mọi người trong nhà:",
    "hideBreakdown": "Ẩn bảng chi tiết",
    "householdIncomeCalculator": {
      "annualDescription": "Nhập thu nhập năm ước tính của mỗi người",
      "biWeeklyDescription": "Nhập thu nhập mỗi 2 tuần ước tính của mỗi người",
      "monthlyDescription": "Nhập thu nhập tháng ước tính của mỗi người",
      "period": {
        "annual": "năm",
        "biWeekly": "2 tuần",
        "monthly": "tháng"
      },
      "title": "Tính thu nhập của bạn",
      "totalIncomeTitle": "Tổng thu nhập hộ gia đình:",
      "totalIncomeValue": "{{total}} /{{period}}",
      "useRange": "Dùng {{label}}"
    },
    "incomePeriod": {
      "annual": "Hàng năm",
      "biWeekly": "Mỗi 2 tuần",
      "monthly": "Hàng tháng"
    },
    "incomeRange": {
      "0-1800": "0$ - 1.800$",
      "0-3700": "0$ - 3.700$",
      "0-44400": "0$ - 44.400$",
      "1600-2600": "1.600$ - 2.600$",
      "2500-3000": "2.500$ - 3.000$",
      "3000-3300": "3.000$ - 3.300$",
      "3300+": "Trên 3.300$",
      "3500-5600": "3.500$ - 5.600$",
      "43000-67000": "43.000$ - 67.000$",
      "5500-6500": "5.500$ - 6.500$",
      "6500-7000": "6.500$ - 7.000$",
      "66000-78000": "66.000$ - 78.000$",
      "7000+": "Trên 7.000$",
      "78000-83000": "78.000$ - 83.000$",
      "83000+": "Trên 83.000$"
    },
    "showBreakdown": "Cần hỗ trợ tính toán? Xem chi tiết",
    "title": "Thu nhập ước tính của hộ gia đình bạn là bao nhiêu?",
    "updateError": "Chúng tôi không thể lưu thu nhập của bạn. Vui lòng thử lại."
  },
  "eligibilityHouseholdMembers": {
    "title": "Hộ gia đình của bạn",
    "you": "Bạn"
  },
  "eligibilityLiveAndCareScreen": {
    "description": "Trẻ phải <bold>sống cùng bạn</bold> hơn <bold>nửa năm</bold> và bạn phải <bold>chu cấp hơn một nửa</bold> chi phí hàng năm (ăn ở, học tập, y tế). Bao gồm cả trẻ không cùng huyết thống.",
    "formDescription": "Thêm bất kỳ con đẻ, con riêng, cháu, hoặc con nuôi dưới 19 tuổi nào sống cùng và được bạn hỗ trợ tài chính.",
    "formTitle": "Thông tin về trẻ em bạn đang nuôi dưỡng",
    "supporterDescription": "Trẻ phải <bold>sống cùng {{supporterFirstName}}</bold> hơn <bold>nửa năm</bold> và {{supporterFirstName}} phải <bold>chu cấp hơn một nửa</bold> chi phí hàng năm.",
    "supporterFormDescription": "Thêm bất kỳ trẻ em nào dưới 19 tuổi đang sống cùng {{supporterFirstName}}.",
    "supporterFormTitle": "Thông tin về con cái của {{supporterFirstName}}",
    "supporterTitle": "{{supporterFirstName}} có sống cùng và chăm sóc trẻ em nào dưới 19 tuổi không?",
    "title": "Bạn có đang sống cùng và chăm sóc trẻ em nào dưới 19 tuổi không?"
  },
  "eligibilityMaritalStatusScreen": {
    "description": "Thông tin này giúp chúng tôi hiểu rõ gia đình bạn để biết bạn phù hợp với chương trình nào.",
    "formDescription": "Chúng tôi cần một số thông tin cơ bản về vợ/chồng hoặc bạn đời của bạn.",
    "formTitle": "Thông tin về vợ/chồng hoặc bạn đời",
    "supporterFormDescription": "Chúng tôi cần một số thông tin về vợ/chồng hoặc bạn đời của {{supporterFirstName}}.",
    "supporterFormTitle": "Thông tin về vợ/chồng của {{supporterFirstName}}",
    "supporterTitle": "Tình trạng hôn nhân của {{supporterFirstName}} là gì?",
    "title": "Tình trạng hôn nhân của bạn là gì?"
  },
  "eligibilityParentGuardianStudentScreen": {
    "description": "Bạn phải <bold>chu cấp hơn một nửa</bold> chi phí hàng năm cho họ (ăn ở, học tập, y tế).",
    "formDescription": "Thêm sinh viên toàn thời gian từ 18–21 tuổi mà bạn là cha mẹ hoặc người giám hộ hợp pháp.",
    "formTitle": "Thông tin về sinh viên bạn hỗ trợ",
    "supporterDescription": "{{supporterFirstName}} phải <bold>chu cấp hơn một nửa</bold> chi phí hàng năm cho họ.",
    "supporterFormDescription": "Thêm sinh viên toàn thời gian từ 18–21 tuổi mà {{supporterFirstName}} là cha mẹ hoặc người giám hộ.",
    "supporterFormTitle": "Thông tin về sinh viên mà {{supporterFirstName}} hỗ trợ",
    "supporterTitle": "{{supporterFirstName}} có phải là cha mẹ hoặc người giám hộ của sinh viên nào từ 18-21 tuổi không?",
    "title": "Bạn có phải là cha mẹ hoặc người giám hộ của sinh viên nào từ 18-21 tuổi không?"
  },
  "eligibilitySomeoneSupportsYou": {
    "description": "Bao gồm chi phí ăn ở, học tập và hóa đơn y tế.",
    "errors": {
      "updateFailed": "Chúng tôi không thể lưu các thay đổi đó. Vui lòng thử lại."
    },
    "formDescription": "Thêm người chu cấp hơn một nửa chi phí tài chính hàng năm cho bạn, như cha mẹ hoặc người giám hộ.",
    "formTitle": "Thông tin về người hỗ trợ bạn",
    "options": {
      "disabled": "Có, tôi bị khuyết tật và sống quanh năm với người hỗ trợ tôi.",
      "fullTimeStudent": "Có, tôi là sinh viên toàn thời gian và được cha mẹ/người giám hộ hỗ trợ.",
      "personSupportsMe": "Có, tôi sống hơn nửa năm với người hỗ trợ tôi.",
      "relativeSupportsMe": "Có, tôi sống hơn nửa năm với một người thân hỗ trợ tôi."
    },
    "title": "Có ai hỗ trợ hơn một nửa chi phí sinh hoạt hàng năm cho bạn không?"
  },
  "eligibilitySpecialConditionsScreen": {
    "addDetails": "Thêm chi tiết",
    "conditions": {
      "blind": "Có người khiếm thị",
      "breastCancer": "Có người mắc ung thư vú",
      "cervicalCancer": "Có người mắc ung thư cổ tử cung",
      "disabled": "Có người khuyết tật (SSDI)",
      "fosterCare": "Từng ở trung tâm bảo trợ khi đủ 18 tuổi",
      "pregnant": "Có người đang mang thai"
    },
    "description": "Vui lòng chọn bất kỳ tình huống nào đúng với các thành viên trong nhà.",
    "errors": {
      "allUpdatesFailed": "Chúng tôi không thể lưu các thay đổi đó. Vui lòng thử lại."
    },
    "pregnancyDetails": {
      "estimatedDueDate": "Ước tính ngày dự sinh",
      "numberOfBabies": "Số lượng em bé dự kiến",
      "title": "Chi tiết thai kỳ"
    },
    "pregnancyInfo": {
      "babiesWithCount_one": "{{count}} bé • Dự sinh {{date}}",
      "babiesWithCount_other": "{{count}} bé • Dự sinh {{date}}"
    },
    "title": "Các trường hợp đặc biệt"
  },
  "eligibilitySupportDisabledIndividualScreen": {
    "description": "Có thể là bất kỳ ai — con cái, anh chị em, ông bà — ở mọi lứa tuổi. Bạn phải <bold>chu cấp hơn một nửa</bold> chi phí hàng năm cho họ.",
    "formDescription": "Thêm người khuyết tật sống cùng bạn quanh năm và được bạn hỗ trợ tài chính.",
    "formTitle": "Thông tin về người khuyết tật bạn hỗ trợ",
    "supporterDescription": "Có thể là bất kỳ ai. {{supporterFirstName}} phải <bold>chu cấp hơn một nửa</bold> chi phí hàng năm cho họ.",
    "supporterFormDescription": "Thêm người khuyết tật sống cùng {{supporterFirstName}} quanh năm và được hỗ trợ tài chính.",
    "supporterFormTitle": "Thông tin về người mà {{supporterFirstName}} hỗ trợ",
    "supporterTitle": "{{supporterFirstName}} có hỗ trợ tài chính cho người khuyết tật sống cùng quanh năm không?",
    "title": "Bạn có hỗ trợ tài chính cho người khuyết tật sống cùng quanh năm không?"
  },
  "eligibilitySupportOtherRelativesScreen": {
    "description": "Họ phải <bold>sống cùng bạn</bold> hơn nửa năm và được bạn <bold>chu cấp hơn một nửa</bold> chi phí. Bao gồm họ hàng gần, xa, con riêng hoặc gia đình bên vợ/chồng.",
    "formDescription": "Thêm bất kỳ người thân nào sống cùng và được bạn hỗ trợ tài chính.",
    "formTitle": "Thông tin về người thân bạn hỗ trợ",
    "supporterDescription": "Họ phải <bold>sống cùng {{supporterFirstName}}</bold> hơn nửa năm và được hỗ trợ hơn một nửa chi phí.",
    "supporterFormDescription": "Thêm người thân sống cùng {{supporterFirstName}} phần lớn thời gian trong năm.",
    "supporterFormTitle": "Thông tin người thân mà {{supporterFirstName}} hỗ trợ",
    "supporterTitle": "{{supporterFirstName}} có đang hỗ trợ người thân sống chung về mặt tài chính không?",
    "title": "Bạn có đang hỗ trợ người thân sống chung về mặt tài chính không?"
  },
  "homeScreen": {
    "addMember": "Thêm thành viên",
    "applicationSubmittedCard_multiple": "Bạn đã nộp đơn đăng ký <programs /> cho {{memberNames}}. Chúng tôi sẽ xem xét và liên hệ nếu cần thêm thông tin.",
    "applicationSubmittedCard_single": "Bạn đã nộp đơn đăng ký <programs /> cho {{memberNames}}. Chúng tôi sẽ xem xét và liên hệ nếu cần thêm thông tin.",
    "applicationSubmittedCard_singleMarketplace": "Bạn đã nộp đơn đăng ký <programs /> cho {{memberNames}}. Chúng tôi sẽ xem xét và liên hệ nếu cần thêm thông tin.",
    "checkEligibility": "Kiểm tra điều kiện gia đình",
    "checkEligibilityCompact": "Kiểm tra điều kiện",
    "devScenarioActive": "Kịch bản mô phỏng đang bật — bảng điều khiển đang hiển thị dữ liệu thử nghiệm.",
    "devScenarioReset": "Đặt lại",
    "eligibilityCardCompactNotStarted": "Xem bạn có thể đủ điều kiện cho chương trình nào",
    "eligibilityCardCompactStarted": "Tiếp tục để xem bạn có thể đủ điều kiện cho chương trình nào",
    "eligibilityCardNotStarted": "Bắt đầu kiểm tra từng bước để xem gia đình bạn phù hợp với chương trình nào",
    "eligibilityCardStarted": "Tiếp tục kiểm tra để xem các chương trình bảo hiểm phù hợp",
    "household": "Hộ gia đình",
    "logout": "Đăng xuất",
    "nextSteps": "Bước tiếp theo",
    "recheckEligibility": "Kiểm tra lại điều kiện"
  },
  "householdMemberScreen": {
    "applicantDocuments": "Tài liệu người đăng ký",
    "checkCoverage": "Kiểm tra bảo hiểm",
    "deleteButton": "Xóa {{memberFullName}} khỏi gia đình",
    "deleteDialog": {
      "description": "Hành động này sẽ xóa vĩnh viễn {{memberFullName}}. Mọi thông tin và tài liệu của họ sẽ bị mất và không thể khôi phục.",
      "title": "Xóa thành viên"
    },
    "deleteToast": {
      "error": "Chúng tôi không thể xóa thành viên này. Vui lòng thử lại.",
      "success": "Đã xóa thành viên thành công"
    },
    "profileInformation": "Thông tin cá nhân"
  },
  "landingScreen": {
    "goToAuth": "Đến màn hình xác thực"
  },
  "languageSelectorModal": {
    "title": "Chọn ngôn ngữ"
  },
  "languages": {
    "arabicDescription": "Tiếng Ả Rập",
    "chineseSimplifiedDescription": "Tiếng Trung (Giản thể)",
    "englishDescription": "Tiếng Anh",
    "haitianCreoleDescription": "Tiếng Haiti Creole",
    "russianDescription": "Tiếng Nga",
    "spanishDescription": "Tiếng Tây Ban Nha",
    "tagalogDescription": "Tiếng Tagalog",
    "vietnameseDescription": "Tiếng Việt"
  },
  "memberFormSubmission": {
    "error": "Chúng tôi không thể lưu các thay đổi đó. Vui lòng thử lại.",
    "success": "Đã cập nhật thành viên thành công"
  },
  "mfaPhoneScreen": {
    "phoneNumberLabel": "Số điện thoại",
    "phoneNumberPlaceholder": "(555) 000-0000",
    "sendVerificationCodeText": "Chúng tôi sẽ gửi cho bạn một mã xác nhận.",
    "subtitle": "Chúng tôi dùng số này để bảo vệ tài khoản của bạn.",
    "title": "Số điện thoại của bạn là gì?"
  },
  "mfaVerifyScreen": {
    "getNewCode": "Nhận mã mới",
    "subtitle": "Vui lòng nhập mã 6 chữ số chúng tôi đã gửi đến\n<bold>{{phoneNumber}}</bold>",
    "title": "Chúng tôi đã gửi mã cho bạn",
    "verificationCodeLabel": "Mã xác nhận"
  },
  "notFound": {
    "cta": "Quay lại Trang chủ",
    "description": "Trang bạn đang tìm không còn ở đây nữa.",
    "title": "Không tìm thấy trang."
  },
  "npsSurveyScreen": {
    "highFeedbackLabel": "Bạn thích điều gì nhất về Pointcare? (không bắt buộc)",
    "highFeedbackPlaceholder": "Cho chúng tôi biết điều gì nổi bật",
    "lowFeedbackLabel": "Chúng tôi có thể làm gì tốt hơn? (không bắt buộc)",
    "lowFeedbackPlaceholder": "Cho chúng tôi biết điều gì chưa ổn...",
    "mediumFeedbackLabel": "Điều gì có thể khiến bạn cho điểm 10? (không bắt buộc)",
    "mediumFeedbackPlaceholder": "Điều gì sẽ làm trải nghiệm tốt hơn...",
    "scaleHighLabel": "→ Rất có khả năng",
    "scaleLowLabel": "→ Hoàn toàn không có khả năng",
    "submitButton": "Gửi phản hồi",
    "subtitle": "Câu trả lời của bạn sẽ không bao giờ được chia sẻ với các chương trình bạn đã nộp đơn.",
    "success": "Đã gửi phản hồi thành công.",
    "testimonialLabel": "Chúng tôi có thể chia sẻ phản hồi của bạn trên trang web của mình để giúp nhiều người hơn tìm được bảo hiểm không? Chúng tôi sẽ chỉ dùng tên của bạn.",
    "title": "Khả năng bạn giới thiệu Pointcare cho bạn bè hoặc người thân là bao nhiêu?"
  },
  "onboarding": {
    "benefits": {
      "description": "Pointcare giúp hơn 1,8 triệu bệnh nhân tại Mỹ tìm và giữ bảo hiểm y tế của họ.",
      "firstItem": "Tìm hiểu ai hội đủ điều kiện trong vòng 5 phút",
      "firstItem_AGING_INTO_MEDICARE": "Tìm chương trình Medicare phù hợp",
      "firstItem_AGING_INTO_MEDICARE_awareness": "Luôn cập nhật về các mốc thời gian",
      "firstItem_LAPSE": "Tìm hiểu ai hội đủ điều kiện trong vòng 5 phút",
      "firstItem_QR_CODE": "Tìm hiểu ai hội đủ điều kiện trong vòng 5 phút",
      "firstItem_RECURRING_WORK_REQUIREMENT": "Không bao giờ lỡ các thời hạn quan trọng",
      "firstItem_REDETERMINATION": "Không bao giờ lỡ các thời hạn quan trọng",
      "firstItem_SELF_PAY_CONVERSION": "Tìm hiểu ai hội đủ điều kiện trong vòng 5 phút",
      "firstItem_SERVICE_INTRODUCTION_medicaid": "Không bao giờ lỡ các thời hạn quan trọng",
      "firstItem_SERVICE_INTRODUCTION_medicare": "Kiểm tra quyền lợi mọi người trong 5 phút",
      "freeToUse": "Hỗ trợ miễn phí - không phí ẩn",
      "infoIsPrivate": "Mọi thông tin đều được bảo mật",
      "title": "{{clinicName}} đã hợp tác với Pointcare để hỗ trợ gia đình bạn",
      "titleNoClinic": "Pointcare luôn ở đây để hỗ trợ gia đình bạn"
    },
    "buttons": {
      "createMyProfile": "Tạo hồ sơ của tôi",
      "getStarted": "Bắt đầu"
    },
    "concerns": {
      "description": "Chọn điều bạn quan tâm nhất — chúng tôi sẽ chỉ cho bạn cách chúng tôi có thể giúp.",
      "description_SERVICE_INTRODUCTION_medicare": "Chọn mục mô tả đúng nhất về bảo hiểm hiện tại.",
      "title": "Điều gì khiến bạn thấy khó khăn nhất khi mua bảo hiểm cho gia đình?",
      "title_SERVICE_INTRODUCTION_medicare": "Gia đình bạn đang có loại bảo hiểm Medicare nào?"
    },
    "figuringOutWhenToRenew": {
      "option": "Biết khi nào cần gia hạn",
      "subtext": "Chúng tôi sẽ theo dõi ngày gia hạn cho mọi người và nhắc bạn kịp thời."
    },
    "figuringOutWhenToSubmitRequirements": {
      "option": "Biết khi nào cần nộp yêu cầu",
      "subtext": "Chúng tôi sẽ theo dõi các thời hạn công việc và nhắc bạn trước khi quá muộn."
    },
    "imNotSure": {
      "option": "Tôi không chắc",
      "subtext": "Chúng tôi sẽ đảm bảo chương trình của mọi người luôn hoạt động tốt."
    },
    "intro": {
      "description": "Nhiều người không phải trả phí. Những người khác chỉ trả khoảng 20–30$ mỗi tháng. Chúng tôi sẽ hỏi vài câu đơn giản để tìm lựa chọn tốt nhất.",
      "description_AGING_INTO_MEDICARE": "Có thể bạn đang nhận được nhiều lời mời chào. Với tư cách là đối tác y tế, chúng tôi sẽ giúp bạn chọn đúng chương trình.",
      "description_AGING_INTO_MEDICARE_awareness": "Có thể bạn đang nhận được nhiều lời mời chào. Với tư cách là đối tác y tế, chúng tôi sẽ giúp bạn chọn đúng chương trình.",
      "description_LAPSE": "7 trên 10 người có thể đăng ký lại bảo hiểm miễn phí hoặc giá rẻ. Chúng tôi sẽ hỗ trợ bạn từng bước.",
      "description_QR_CODE": "Nhiều người không phải trả phí. Những người khác chỉ trả rất ít. Hãy cùng tìm lựa chọn tốt nhất cho gia đình bạn.",
      "description_RECURRING_WORK_REQUIREMENT": "Quy định mới yêu cầu chứng minh thu nhập. Chúng tôi sẽ kiểm tra xem ai được miễn trừ và hỗ trợ bạn từ đó.",
      "description_REDETERMINATION": "Bạn cần xác nhận hoặc cập nhật thông tin để giữ bảo hiểm. Chúng tôi sẽ đồng hành cùng bạn.",
      "description_SELF_PAY_CONVERSION": "Nhiều người không phải trả phí. Hãy cùng trả lời vài câu hỏi để tìm chương trình phù hợp.",
      "description_SERVICE_INTRODUCTION_medicaid": "Chúng tôi theo dõi bảo hiểm, hỗ trợ gia hạn và hướng dẫn mọi vấn đề phát sinh - hoàn toàn miễn phí.",
      "description_SERVICE_INTRODUCTION_medicare": "Chúng tôi giúp bạn hiểu rõ bảo hiểm, tìm thêm quyền lợi và đảm bảo bạn không bỏ lỡ điều gì.",
      "title": "Để có được bảo hiểm y tế không khó. Gia đình bạn có thể đủ điều kiện tham gia <colorEmphasis>chương trình bảo hiểm miễn phí hoặc chi phí thấp</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE": "Có vẻ ai đó trong gia đình đã đủ điều kiện nhận Medicare được <colorEmphasis>{{count}} tháng</colorEmphasis>. Chúng tôi ở đây để giúp.",
      "title_AGING_INTO_MEDICARE_awareness_one": "Có vẻ ai đó trong gia đình sẽ đủ điều kiện nhận Medicare <colorEmphasis>trong {{monthsToTurning65}} tháng tới</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_awareness_other": "Có vẻ ai đó trong gia đình sẽ đủ điều kiện nhận Medicare <colorEmphasis>trong {{monthsToTurning65}} tháng tới</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_one": "Đã đủ điều kiện nhận Medicare được <colorEmphasis>{{count}} tháng</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_other": "Đã đủ điều kiện nhận Medicare được <colorEmphasis>{{count}} tháng</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_zero": "Có vẻ ai đó vừa đủ điều kiện nhận Medicare <colorEmphasis>bắt đầu từ tháng này</colorEmphasis>.",
      "title_LAPSE": "Có vẻ ai đó đã mất bảo hiểm {{payerName}} vào ngày <colorEmphasis>{{lapseDate}}</colorEmphasis>. Chúng tôi sẽ giúp họ lấy lại bảo hiểm.",
      "title_QR_CODE": "Gia đình bạn có thể có <colorEmphasis>bảo hiểm y tế miễn phí hoặc giá rẻ</colorEmphasis>. Hãy cùng tìm hiểu.",
      "title_RECURRING_WORK_REQUIREMENT_one": "Yêu cầu công việc của {{payerName}} sẽ đến hạn <colorEmphasis>trong 1 tháng tới</colorEmphasis>. Hãy cùng giữ bảo hiểm.",
      "title_RECURRING_WORK_REQUIREMENT_other": "Yêu cầu công việc của {{payerName}} sẽ đến hạn <colorEmphasis>trong {{count}} tháng tới</colorEmphasis>.",
      "title_RECURRING_WORK_REQUIREMENT_zero": "Yêu cầu công việc của {{payerName}} đến hạn <colorEmphasis>trong tháng này</colorEmphasis>.",
      "title_REDETERMINATION_one": "Việc gia hạn {{payerName}} sẽ đến hạn <colorEmphasis>trong 1 tháng tới</colorEmphasis>.",
      "title_REDETERMINATION_other": "Việc gia hạn {{payerName}} sẽ đến hạn <colorEmphasis>trong {{count}} tháng tới</colorEmphasis>.",
      "title_REDETERMINATION_zero": "Việc gia hạn {{payerName}} đến hạn <colorEmphasis>trong tháng này</colorEmphasis>.",
      "title_SERVICE_INTRODUCTION_medicaid": "Chúng tôi giúp gia đình bạn <colorEmphasis>duy trì bảo hiểm {{payerName}}.</colorEmphasis>",
      "title_SERVICE_INTRODUCTION_medicare": "Gia đình bạn đã nhận được <colorEmphasis>đầy đủ quyền lợi từ {{payerName}} chưa?</colorEmphasis>"
    },
    "keepingMyCurrentDoctors": {
      "option": "Giữ bác sĩ hiện tại",
      "subtext": "Chúng tôi giúp tìm chương trình có bao gồm các bác sĩ gia đình bạn đang khám."
    },
    "meetingRequirements": {
      "option": "Đáp ứng các yêu cầu",
      "subtext": "Chúng tôi hỗ trợ mọi người hoàn thành và nộp các yêu cầu về công việc."
    },
    "missingEnrolmentDeadline": {
      "option": "Bỏ lỡ thời hạn đăng ký",
      "subtext": "Chúng tôi sẽ báo cho bạn biết khi nào cần đăng ký để tránh bị phạt."
    },
    "nextSteps": {
      "step1Description": "Giới thiệu về bản thân",
      "step1Duration": "2 phút",
      "step1Title": "Tạo hồ sơ",
      "step2Description": "Các chương trình gia đình bạn phù hợp",
      "step2Description_AGING_INTO_MEDICARE": "Kiểm tra tình trạng hiện tại",
      "step2Description_AGING_INTO_MEDICARE_awareness": "Kiểm tra tình trạng hiện tại",
      "step2Description_LAPSE": "Các chương trình gia đình bạn phù hợp",
      "step2Description_QR_CODE": "Các chương trình gia đình bạn phù hợp",
      "step2Description_RECURRING_WORK_REQUIREMENT": "Kiểm tra xem ai được miễn trừ hoặc đang đi đúng hướng",
      "step2Description_RECURRING_WORK_REQUIREMENT_awareness": "Kiểm tra xem ai được miễn trừ hoặc đang đi đúng hướng",
      "step2Description_REDETERMINATION": "Đội ngũ của chúng tôi sẽ liên hệ",
      "step2Description_REDETERMINATION_awareness": "Bao gồm thông tin liên lạc cơ bản",
      "step2Description_SELF_PAY_CONVERSION": "Các chương trình gia đình bạn phù hợp",
      "step2Description_SERVICE_INTRODUCTION_medicaid": "Kiểm tra tình trạng hiện tại",
      "step2Description_SERVICE_INTRODUCTION_medicare": "Kiểm tra tình trạng hiện tại",
      "step2Description_SERVICE_INTRODUCTION_medicare_partABorD": "Kiểm tra tình trạng hiện tại",
      "step2Duration": "5 phút",
      "step2Duration_AGING_INTO_MEDICARE": "2 phút",
      "step2Duration_AGING_INTO_MEDICARE_awareness": "2 phút",
      "step2Duration_LAPSE": "5 phút",
      "step2Duration_QR_CODE": "5 phút",
      "step2Duration_RECURRING_WORK_REQUIREMENT": "5 phút",
      "step2Duration_RECURRING_WORK_REQUIREMENT_awareness": "5 phút",
      "step2Duration_REDETERMINATION": "2 phút",
      "step2Duration_SELF_PAY_CONVERSION": "5 phút",
      "step2Duration_SERVICE_INTRODUCTION_medicaid": "2 phút",
      "step2Duration_SERVICE_INTRODUCTION_medicare": "2 phút",
      "step2Duration_SERVICE_INTRODUCTION_medicare_partABorD": "2 phút",
      "step2Title": "Tìm lựa chọn cho bạn",
      "step2Title_AGING_INTO_MEDICARE": "Kiểm tra bảo hiểm",
      "step2Title_AGING_INTO_MEDICARE_awareness": "Kiểm tra bảo hiểm",
      "step2Title_LAPSE": "Tìm lựa chọn cho bạn",
      "step2Title_QR_CODE": "Tìm lựa chọn cho bạn",
      "step2Title_RECURRING_WORK_REQUIREMENT": "Kiểm tra yêu cầu",
      "step2Title_RECURRING_WORK_REQUIREMENT_awareness": "Kiểm tra yêu cầu",
      "step2Title_REDETERMINATION": "Yêu cầu hỗ trợ gia hạn",
      "step2Title_REDETERMINATION_awareness": "Thêm thông tin gia đình",
      "step2Title_SELF_PAY_CONVERSION": "Tìm lựa chọn cho bạn",
      "step2Title_SERVICE_INTRODUCTION_medicaid": "Kiểm tra bảo hiểm",
      "step2Title_SERVICE_INTRODUCTION_medicare": "Kiểm tra bảo hiểm",
      "step2Title_SERVICE_INTRODUCTION_medicare_partABorD": "Kiểm tra bảo hiểm",
      "step3Description": "Chúng tôi sẽ lo phần còn lại!",
      "step3Description_AGING_INTO_MEDICARE": "Chúng tôi sẽ lo phần còn lại!",
      "step3Description_AGING_INTO_MEDICARE_awareness": "Chúng tôi sẽ cập nhật và giúp bạn sẵn sàng",
      "step3Description_LAPSE": "Chúng tôi sẽ lo phần còn lại!",
      "step3Description_QR_CODE": "Chúng tôi sẽ lo phần còn lại!",
      "step3Description_RECURRING_WORK_REQUIREMENT": "Chúng tôi sẽ hướng dẫn bạn",
      "step3Description_RECURRING_WORK_REQUIREMENT_awareness": "Chúng tôi sẽ cập nhật và hỗ trợ gia đình đáp ứng yêu cầu",
      "step3Description_REDETERMINATION": "Chúng tôi sẽ hướng dẫn bạn",
      "step3Description_REDETERMINATION_awareness": "Chúng tôi sẽ cập nhật và giúp bạn sẵn sàng",
      "step3Description_SELF_PAY_CONVERSION": "Chúng tôi sẽ lo phần còn lại!",
      "step3Description_SERVICE_INTRODUCTION_medicaid": "Chúng tôi sẽ báo cho bạn trước",
      "step3Description_SERVICE_INTRODUCTION_medicare": "Xem những gì có trong chương trình của mọi người",
      "step3Description_SERVICE_INTRODUCTION_medicare_partABorD": "Mở rộng quyền lợi",
      "step3Duration": "15 phút",
      "step3Duration_SERVICE_INTRODUCTION_medicare": "1 phút",
      "step3Title": "Gửi đơn đăng ký",
      "step3Title_AGING_INTO_MEDICARE": "Gửi đơn Medicare",
      "step3Title_AGING_INTO_MEDICARE_awareness": "Sẵn sàng cho Medicare",
      "step3Title_LAPSE": "Gửi đơn đăng ký",
      "step3Title_QR_CODE": "Gửi đơn đăng ký",
      "step3Title_RECURRING_WORK_REQUIREMENT": "Nộp yêu cầu",
      "step3Title_RECURRING_WORK_REQUIREMENT_awareness": "Luôn dẫn đầu yêu cầu",
      "step3Title_REDETERMINATION": "Gửi gia hạn",
      "step3Title_REDETERMINATION_awareness": "Chủ động với việc gia hạn",
      "step3Title_SELF_PAY_CONVERSION": "Gửi đơn đăng ký",
      "step3Title_SERVICE_INTRODUCTION_medicaid": "Không bao giờ trễ hạn",
      "step3Title_SERVICE_INTRODUCTION_medicare": "Kiểm tra quyền lợi",
      "step3Title_SERVICE_INTRODUCTION_medicare_partABorD": "Khám phá các lựa chọn Medicare",
      "title": "Bạn sẵn sàng tham gia bảo hiểm y tế cho gia đình mình chưa?",
      "title_RECURRING_WORK_REQUIREMENT": "Cùng duy trì bảo hiểm cho gia đình",
      "title_RECURRING_WORK_REQUIREMENT_awareness": "Cùng duy trì bảo hiểm cho gia đình",
      "title_REDETERMINATION": "Cùng duy trì bảo hiểm cho gia đình",
      "title_REDETERMINATION_awareness": "Cùng duy trì bảo hiểm cho gia đình",
      "title_SERVICE_INTRODUCTION_medicaid": "Cùng duy trì bảo hiểm cho gia đình",
      "title_SERVICE_INTRODUCTION_medicare": "Cùng duy trì bảo hiểm cho gia đình",
      "title_SERVICE_INTRODUCTION_medicare_partABorD": "Cùng duy trì bảo hiểm cho gia đình"
    },
    "notKnowingHowToGetCovered": {
      "option": "Không biết cách để có bảo hiểm",
      "subtext": "Chúng tôi sẽ hướng dẫn chi tiết từng bước để mọi người đều có bảo hiểm."
    },
    "notKnowingImCovered": {
      "option": "Không biết ai đã được bảo hiểm",
      "subtext": "Chúng tôi có thể kiểm tra xem ai đã có bảo hiểm và hỗ trợ nếu bạn chưa có.",
      "subtext_RECURRING_WORK_REQUIREMENT": "Chúng tôi sẽ kiểm tra bảo hiểm và hỗ trợ nếu cần thiết.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "Chúng tôi sẽ kiểm tra bảo hiểm và hỗ trợ nếu cần thiết.",
      "subtext_REDETERMINATION": "Chúng tôi sẽ kiểm tra bảo hiểm và hỗ trợ nếu cần thiết.",
      "subtext_REDETERMINATION_awareness": "Chúng tôi sẽ kiểm tra bảo hiểm và hỗ trợ nếu cần thiết.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Chúng tôi sẽ kiểm tra bảo hiểm và hỗ trợ nếu cần thiết."
    },
    "paperwork": {
      "option": "Giấy tờ quá nhiều hoặc rắc rối",
      "subtext": "Chúng tôi xử lý mọi giấy tờ cho gia đình bạn - từ đăng ký đến gia hạn.",
      "subtext_SERVICE_INTRODUCTION": "Chúng tôi đại diện cho cơ sở y tế của bạn để tìm lựa chọn tốt nhất cho sức khỏe gia đình."
    },
    "partAB": {
      "option": "Phần A & B (Medicare)",
      "subtext": "Chúng tôi tìm lựa chọn tốt nhất, dù là chương trình cũ hay Medicare Advantage (Phần C)."
    },
    "partABD": {
      "option": "Phần A, B, & D (Medicare + Thuốc)",
      "subtext": "Chúng tôi tìm lựa chọn tốt nhất, dù là chương trình cũ hay Medicare Advantage (Phần C)."
    },
    "partC": {
      "option": "Phần C (Medicare Advantage)",
      "subtext": "Chúng tôi sẽ đảm bảo chương trình hiện tại vẫn phù hợp với mọi người."
    },
    "payingForDoctor": {
      "option": "Chi phí khám bệnh & tiền thuốc",
      "subtext": "Chúng tôi giúp tìm bảo hiểm giúp giảm chi phí khám bác sĩ và thuốc men."
    },
    "somethingElse": {
      "option": "Vấn đề khác",
      "subtext": "Chúng tôi sẽ giúp mọi người có và giữ vững bảo hiểm.",
      "subtext_AGING_INTO_MEDICARE": "Chúng tôi hướng dẫn bạn đăng ký Medicare - từng bước một.",
      "subtext_AGING_INTO_MEDICARE_awareness": "Chúng tôi hướng dẫn bạn đăng ký Medicare - từng bước một.",
      "subtext_RECURRING_WORK_REQUIREMENT": "Chúng tôi giúp mọi người giữ bảo hiểm - không lo bất ngờ.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "Chúng tôi giúp mọi người giữ bảo hiểm - không lo bất ngờ.",
      "subtext_REDETERMINATION": "Bỏ qua giấy tờ rắc rối. Chúng tôi giúp mọi người duy trì bảo hiểm.",
      "subtext_REDETERMINATION_awareness": "Bỏ qua giấy tờ rắc rối. Chúng tôi giúp mọi người duy trì bảo hiểm.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Bỏ qua giấy tờ rắc rối. Chúng tôi giúp mọi người duy trì bảo hiểm.",
      "subtext_SERVICE_INTRODUCTION_medicare": "Chúng tôi đảm bảo chương trình của mọi người luôn hiệu quả."
    },
    "submittingRenewals": {
      "option": "Nộp hồ sơ gia hạn",
      "subtext": "Chúng tôi xử lý việc gia hạn cho mọi người. Chỉ cần trả lời vài câu hỏi đơn giản."
    },
    "tooManyMedicareAdsAndCalls": {
      "option": "Quá nhiều quảng cáo và cuộc gọi Medicare",
      "subtext": "Chúng tôi giúp bạn loại bỏ phiền phức và tìm đúng chương trình."
    },
    "variants": {
      "improvedVerbiage": {
        "benefits": {
          "description": "Pointcare giúp hơn 1,8 triệu bệnh nhân tìm và giữ bảo hiểm y tế của họ.",
          "firstItem_LAPSE": "Xem ai hội đủ điều kiện trong 5 phút",
          "infoIsPrivate": "Thông tin của bạn được giữ an toàn",
          "title": "{{clinicName}} hợp tác với Pointcare để giúp gia đình bạn"
        },
        "concerns": {
          "description_LAPSE": "Chọn điều bạn quan tâm nhất và chúng tôi sẽ chỉ cho bạn cách chúng tôi có thể giúp.",
          "title_LAPSE": "Điều gì khó khăn nhất khi tìm bảo hiểm cho gia đình bạn?"
        },
        "intro": {
          "description_LAPSE": "Hầu hết mọi người đều đủ điều kiện nhận lại bảo hiểm miễn phí hoặc giá rẻ. Chúng tôi sẽ hỗ trợ bạn từng bước.",
          "title_LAPSE": "Một người trong gia đình bạn đã mất bảo hiểm {{payerName}} vào ngày <colorEmphasis>{{lapseDate}}</colorEmphasis>. Chúng tôi ở đây để giúp họ lấy lại bảo hiểm."
        },
        "nextSteps": {
          "step2Description_LAPSE": "Xem gia đình bạn hội đủ điều kiện cho những gì"
        },
        "paperwork": {
          "option": "Giấy tờ rắc rối"
        }
      }
    }
  },
  "passwordScreen": {
    "forgotPassword": "Quên mật khẩu của bạn?",
    "passwordInputLabel": "Mật khẩu",
    "passwordInputPlaceholder": "Nhập mật khẩu",
    "resetPasswordInstructions": "Chúng tôi đã gửi một liên kết để đặt lại mật khẩu đến <bold>{{email}}</bold>. Mở nó để tạo mật khẩu mới.",
    "subtitle": "Vui lòng nhập mật khẩu để tiếp tục.",
    "title": "Nhập mật khẩu",
    "usernameResetUnavailable": "Tài khoản tên người dùng không thể đặt lại mật khẩu qua email. Hãy gọi cho chúng tôi để được hỗ trợ."
  },
  "profileInformationScreen": {
    "addressComplement": "Số căn hộ, đơn vị, tòa nhà (không bắt buộc)",
    "checkCoverage": "Kiểm tra thử bảo hiểm",
    "coverageStatus": "Tình trạng bảo hiểm: {{status}}",
    "dateOfBirth": "Ngày sinh",
    "email": "Email",
    "firstName": "Tên",
    "homeAddress": "Địa chỉ nhà",
    "lastName": "Họ",
    "mailingAddress": "Địa chỉ nhận thư",
    "mailingAddressComplement": "Số căn hộ, đơn vị, tòa nhà, hộp thư (tùy chọn)",
    "medicaidCaseNumber": "Số hồ sơ Medicaid (không bắt buộc)",
    "medicaidSubscriberId": "Mã số người tham gia Medicaid (không bắt buộc)",
    "noHomeAddress": "Không có địa chỉ nhà cố định",
    "noMailingAddress": "Không có địa chỉ nhận thư",
    "phoneNumber": "Số điện thoại",
    "socialSecurityNumber": "Số An sinh Xã hội",
    "useDifferentMailingAddress": "Dùng địa chỉ nhận thư khác"
  },
  "recheckEligibilityScreen": {
    "button": "Kiểm tra lại điều kiện",
    "title": "Trước khi kiểm tra lại, hãy chắc chắn thông tin các thành viên đã được cập nhật."
  },
  "redeterminationScreen": {
    "addressInformation": "Cập nhật thông tin địa chỉ",
    "alreadyMailedForm": "Đã gửi đơn qua bưu điện hoặc định gửi sớm",
    "caseNumberDescription": "Chúng tôi sẽ dùng số hồ sơ của bạn để gửi đơn gia hạn nhanh hơn!\n\nHãy tìm số này trong biểu mẫu gia hạn hoặc thư khác từ cơ quan tiểu bang về phạm vi bảo hiểm của bạn.",
    "caseNumberDescription_PENDING_FORM": "Chúng tôi sẽ dùng số hồ sơ của bạn để gửi đơn gia hạn nhanh hơn!\n\nHãy tìm số này trong thư từ cơ quan tiểu bang về phạm vi bảo hiểm của bạn.",
    "caseNumberLabel": "Số hồ sơ",
    "caseNumberPlaceholder": "Nhập số hồ sơ",
    "caseNumberTitle": "Hãy thêm số hồ sơ của bạn (không bắt buộc)",
    "description": "Chọn lựa chọn phù hợp nhất",
    "haventReceivedForm": "Chưa nhận được đơn",
    "receivedForm": "Đã nhận được đơn và cần hỗ trợ điền đơn",
    "returnToDashboard": "Quay lại Bảng điều khiển",
    "reviewAddress": "Vui lòng kiểm tra và xác nhận địa chỉ nhà và địa chỉ nhận thư cho tất cả các thành viên trong gia đình. Điều này đảm bảo biểu mẫu gia hạn đến đúng địa chỉ.",
    "successDescription": "Việc gia hạn của bạn đã được xử lý. Chúng tôi sẽ liên hệ nếu có thay đổi.",
    "successDescription_CALL_BACK": "Đội ngũ của chúng tôi sẽ liên hệ trong vòng 1-2 ngày làm việc để hoàn tất việc gia hạn của bạn.",
    "successDescription_PENDING_FORM": "Biểu mẫu gia hạn sẽ được gửi đến địa chỉ đã đăng ký. Hãy để ý thư, email và tin nhắn. Chúng tôi sẽ đảm bảo theo dõi trước thời hạn.",
    "successTitle": "Bạn đã hoàn tất!",
    "successTitle_CALL_BACK": "Chúng tôi sẽ sớm gọi cho bạn.",
    "successTitle_PENDING_FORM": "Bạn đã hoàn tất!",
    "title": "Hạn gia hạn bảo hiểm của một thành viên trong gia đình bạn là {{date}}."
  },
  "redeterminations": {
    "cardAggregated_CALL_BACK": "{{total}} đợt gia hạn Medicaid đang chờ cuộc gọi — đến hạn vào {{dates}}. Hãy để ý điện thoại của bạn.",
    "cardAggregated_NOT_STARTED": "{{total}} đợt gia hạn Medicaid cần bắt đầu.",
    "cardAggregated_PENDING_FORM": "{{total}} biểu mẫu gia hạn Medicaid sắp được gửi đến. Hãy để ý thư, email và tin nhắn.",
    "cardCompact_PENDING_FORM": "Biểu mẫu gia hạn sắp đến — đến hạn vào {{date}}",
    "card_CALL_BACK": "Một người trong gia đình bạn có một đợt gia hạn Medicaid đang chờ cuộc gọi — đến hạn vào {{date}}. Hãy để ý điện thoại của bạn.",
    "card_NOT_STARTED": "Một người trong gia đình bạn có một đợt gia hạn Medicaid đến hạn vào {{date}}.",
    "card_PENDING_FORM": "Một người trong gia đình bạn sắp nhận được biểu mẫu gia hạn Medicaid — đến hạn vào {{date}}. Hãy để ý thư, email và tin nhắn.",
    "due": "Đến hạn {{date}}",
    "medicaidRenewals": "Gia hạn Medicaid",
    "noRenewals": "Chưa có đợt gia hạn nào.",
    "startRenewal": "Bắt đầu gia hạn",
    "status": "Gọi lại",
    "status_CALL_BACK": "Đã yêu cầu cuộc gọi",
    "status_COMPLETED": "Hoàn thành",
    "status_NOT_STARTED": "Chưa bắt đầu",
    "status_PENDING_FORM": "Đang đợi đơn",
    "title": "Gia hạn",
    "updateStatus": "Cập nhật trạng thái"
  },
  "registrationCoverageScreen": {
    "description": "Pointcare có thể tra cứu phạm vi bảo hiểm Medicaid hiện tại của bạn bằng cách sử dụng thông tin bạn cung cấp bên dưới.",
    "title": "Hãy cùng kiểm tra bảo hiểm của bạn"
  },
  "registrationProfileScreen": {
    "description": "Cung cấp chi tiết hồ sơ để sử dụng trong các đơn đăng ký."
  },
  "resetPasswordScreen": {
    "confirmPasswordInputLabel": "Xác nhận mật khẩu mới",
    "confirmPasswordInputPlaceholder": "Nhập lại mật khẩu mới",
    "invalidResetLink": "Liên kết đặt lại mật khẩu không hợp lệ hoặc đã hết hạn. Vui lòng yêu cầu liên kết mới.",
    "passwordInputLabel": "Mật khẩu mới",
    "passwordInputPlaceholder": "Nhập mật khẩu mới",
    "subtitle": "Chọn một mật khẩu mạnh mà bạn chưa từng sử dụng.",
    "title": "Tạo mật khẩu mới",
    "updatePasswordButton": "Cập nhật mật khẩu"
  },
  "sessionTimedOut": {
    "description": "Vì lý do bảo mật, chúng tôi đã đăng xuất bạn do không hoạt động. Vui lòng đăng nhập lại.",
    "loginAgain": "Đăng nhập lại",
    "title": "Bạn đã đăng xuất"
  },
  "sessionTimeout": {
    "countdown": "Còn lại {{time}}",
    "description": "Bạn sắp bị đăng xuất do không hoạt động. Bạn có muốn tiếp tục đăng nhập không?",
    "logOutNow": "Đăng xuất ngay",
    "secureSession": "Phiên bảo mật",
    "stayLoggedIn": "Duy trì đăng nhập",
    "title": "Bạn vẫn còn đó chứ?"
  },
  "signatureField": {
    "signaturePrompt": "Ký tên vào đây"
  },
  "someHouseholdMembersNotUpdated": "Chúng tôi không thể lưu thay đổi cho tất cả mọi người. Vui lòng kiểm tra lại từng thành viên.",
  "support": {
    "callUs": "Gọi chúng tôi",
    "callUsAt": "Gọi cho chúng tôi theo số <underline>{{phoneNumber}}</underline>"
  },
  "workRequirements": {
    "cardActionCompact_START": "Bắt đầu",
    "cardActionCompact_UPLOAD_DOCUMENTS": "Tải lên",
    "cardAction_CONTINUE": "Tiếp tục Yêu cầu công việc",
    "cardAction_START": "Bắt đầu Yêu cầu công việc",
    "cardAction_UPLOAD_DOCUMENTS": "Tải lên tài liệu",
    "cardCompact": "Yêu cầu công việc của Medicaid đến hạn vào {{date}}",
    "card_CONTINUE": "Một người trong gia đình bạn có Yêu cầu công việc của Medicaid đến hạn vào {{date}}. Hãy hoàn tất việc kiểm tra xem ai đang đi đúng hướng hoặc được miễn trừ.",
    "card_START": "Một người trong gia đình bạn có Yêu cầu công việc của Medicaid đến hạn vào {{date}}. Hãy kiểm tra xem bạn đang đi đúng hướng hay được miễn trừ.",
    "card_UPLOAD_DOCUMENTS": "Một người trong gia đình bạn có Yêu cầu công việc của Medicaid đến hạn vào {{date}}. Hãy tải lên tài liệu để luôn đi đúng hướng.",
    "caseNumbers": {
      "description": "Chúng tôi sẽ dùng các số hồ sơ này để nộp giấy tờ cho hộ gia đình bạn.",
      "descriptionSingle": "Chúng tôi sẽ dùng số hồ sơ này để nộp giấy tờ việc làm của {{name}}.",
      "hint": "Hãy tìm các số này trong thư từ cơ quan tiểu bang về phạm vi bảo hiểm của bạn.",
      "hintSingle": "Hãy tìm số này trong thư từ cơ quan tiểu bang về phạm vi bảo hiểm của {{name}}.",
      "memberLabel": "{{name}}",
      "title": "Hãy thêm số hồ sơ của hộ gia đình bạn (không bắt buộc)",
      "titleSingle": "Hãy thêm số hồ sơ của {{name}} (không bắt buộc)"
    },
    "confirmation": {
      "completedDescription": "Nhóm của chúng tôi sẽ xem xét và liên hệ với bạn nếu cần thêm thông tin.",
      "completedTitle": "Chúc mừng, bạn đã hoàn thành <label>Yêu cầu công việc</label>",
      "description": "Vui lòng nhớ hoàn thành các yêu cầu trước đợt gia hạn vào {{date}} của bạn.",
      "title": "<label>Yêu cầu công việc</label> đang được thực hiện",
      "uploadsHint": "Bạn có thể hoàn tất việc tải lên từ Bảng điều khiển khi các tháng tiếp theo được mở."
    },
    "due": "Đến hạn <bold>{{date}}</bold>",
    "exemptions": {
      "description": "Chọn tất cả các mục phù hợp",
      "groups": {
        "BENEFITS_AND_COVERAGE": "Phúc lợi & bảo hiểm",
        "CAREGIVING": "Chăm sóc người khác",
        "HEALTH_AND_RECOVERY": "Sức khỏe & phục hồi",
        "LIFE_SITUATIONS": "Hoàn cảnh sống"
      },
      "options": {
        "CAREGIVER_OF_CHILD_13_OR_YOUNGER": "Cha mẹ hoặc người chăm sóc trẻ từ 13 tuổi trở xuống",
        "CAREGIVER_OF_PERSON_WITH_DISABILITY": "Người chăm sóc người khuyết tật",
        "FOSTER_YOUTH_UNDER_26": "Thanh thiếu niên đang hoặc từng ở nhà nuôi dưỡng, dưới 26 tuổi",
        "INCARCERATED_OR_RELEASED_LAST_90_DAYS": "Đang ở trong trại giam hoặc nhà tù, hoặc đã được thả trong 90 ngày qua",
        "IN_DRUG_OR_ALCOHOL_TREATMENT": "Đang tham gia chương trình điều trị cai nghiện ma túy hoặc rượu",
        "MEDICALLY_FRAIL": "Sức khỏe yếu về mặt y tế",
        "MEETING_SNAP_TANF_WORK_REQUIREMENTS": "Đã đáp ứng yêu cầu công việc của SNAP/TANF",
        "NOT_ENROLLED_OR_ELIGIBLE_FOR_MEDICARE": "Chưa ghi danh hoặc không đủ điều kiện hưởng Medicare",
        "PREGNANT_OR_POSTPARTUM": "Đang mang thai hoặc sau sinh (12 tháng trở xuống)",
        "TRIBAL_MEMBER": "Thành viên của một bộ lạc thổ dân Mỹ được liên bang công nhận",
        "VETERAN_100_PERCENT_DISABILITY": "Cựu chiến binh có mức xếp hạng khuyết tật toàn phần (100%)"
      },
      "title": "Có trường hợp miễn trừ nào dưới đây áp dụng không?"
    },
    "hours": {
      "communityService": "Phục vụ cộng đồng",
      "description_completed": "Thêm số giờ đã hoàn thành của {{name}} cho {{month}}. Để trống nếu không có.",
      "description_expected": "Thêm số giờ dự kiến của {{name}} cho {{month}}. Để trống nếu không có.",
      "employment": "Việc làm",
      "employmentHint": "Nhập số giờ và tiền lương hàng tháng. Chúng tôi sẽ quy đổi tiền lương thành số giờ và tính số nào cao hơn vào yêu cầu.",
      "hoursPerMonth": "giờ / tháng",
      "jobTraining": "Đào tạo nghề",
      "payPerMonth": "$ / tháng",
      "school": "Đi học / học nghề",
      "title": "Báo cáo số giờ cho {{name}}",
      "totalHours": "Tổng số giờ",
      "totalOf": "<bold>{{total}}</bold> / {{required}}"
    },
    "income": {
      "description": "Chọn tất cả các mục phù hợp, hoặc tiếp tục nếu không có ai.",
      "everyone": "Tất cả mọi người ở đây",
      "title": "Ai kiếm được từ ${{amount}} trở lên mỗi tháng?",
      "titleSingle": "{{name}} có kiếm được từ ${{amount}} trở lên mỗi tháng không?"
    },
    "medicaidWorkRequirements": "Yêu cầu công việc của Medicaid",
    "nextSteps": {
      "complete": "Hoàn thành {{completed}} trên {{total}}",
      "description": "Đây là những gì mỗi người cần nộp để giữ bảo hiểm.",
      "needsMoreHours": "Cần thêm {{hours}} giờ / tháng",
      "offrampDescription": "Để giữ bảo hiểm y tế, cần hoàn thành {{hours}} giờ hoạt động được chấp thuận mỗi tháng. Các hoạt động này có thể bao gồm việc làm, đào tạo nghề, đi học, học nghề và/hoặc phục vụ cộng đồng.",
      "opensOn": "Mở vào {{date}}",
      "proofOfExemption": "Bằng chứng miễn trừ",
      "proofOfWork": "Bằng chứng công việc ({{month}})",
      "reasonHours": "Đã báo cáo {{hours}} giờ / tháng",
      "reasonIncome": "Kiếm được từ ${{amount}} trở lên mỗi tháng",
      "reportedOf": "Đã báo cáo {{hours}} trên {{required}} giờ / tháng",
      "status_EXEMPT": "Được miễn trừ",
      "status_MEETS_REQUIREMENTS": "Đáp ứng yêu cầu",
      "title": "Bước tiếp theo cho <label>Yêu cầu công việc</label>",
      "volunteerOpportunities": "Cơ hội tình nguyện"
    },
    "noWorkRequirements": "Hộ gia đình của bạn không có yêu cầu công việc nào.",
    "progress_ACTION_NEEDED": "Cần hành động",
    "progress_COMPLETED": "Hoàn thành",
    "progress_UP_TO_DATE": "Đã cập nhật",
    "recheck": "Kiểm tra lại Yêu cầu công việc",
    "sectionTitle": "Yêu cầu công việc",
    "whatAreDescription": "Một luật liên bang mới yêu cầu một số người lớn có Medicaid phải làm việc, học nghề, đi học hoặc làm tình nguyện {{hours}} giờ/tháng. Điều này chỉ áp dụng cho người lớn từ {{minAge}} đến {{maxAge}} tuổi.",
    "who": {
      "checkAll": "Kiểm tra tất cả thành viên trong hộ gia đình",
      "noEligibleMembers": "Không có ai trong hộ gia đình của bạn từ {{minAge}} đến {{maxAge}} tuổi, vì vậy không cần kiểm tra ai.",
      "question": "<bold>Bạn muốn kiểm tra cho ai? Chúng tôi sẽ xem họ đang đi đúng hướng hay được miễn trừ và hỗ trợ bạn từ đó.</bold>",
      "title": "Kiểm tra tình trạng <label>Yêu cầu công việc</label> của hộ gia đình"
    }
  }
}
